import { Layers } from "lucide-react";

export interface SequenceListItem {
  id: string;
  title: string | null;
  frameCount: number;
  createdAt: string | null;
  conversationId: string | null;
  thumbnailUrl: string | null;
  isInGallery: boolean | null;
  galleryCategory: string | null;
}

interface Props {
  sequence: SequenceListItem;
  onOpen: (id: string) => void;
}

export default function SequenceCard({ sequence, onOpen }: Props): JSX.Element {
  return (
    <button
      onClick={() => onOpen(sequence.id)}
      className="group relative aspect-[9/16] rounded-xl overflow-hidden bg-zinc-900 border border-white/[0.08] hover:border-[#ef3e29]/60 transition-all text-left shadow-lg"
      data-testid={`sequence-card-${sequence.id}`}
    >
      {sequence.thumbnailUrl ? (
        <img
          src={sequence.thumbnailUrl}
          alt={sequence.title ?? "Stories sequence"}
          className="absolute inset-0 w-full h-full object-cover"
          loading="lazy"
        />
      ) : (
        <div className="absolute inset-0 bg-gradient-to-br from-zinc-800 to-black" />
      )}

      {/* Stacked-cards effect (back-of-deck hint) */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1.5 left-1.5 right-3 bottom-3 rounded-xl border border-white/15 bg-white/[0.02]" />
        <div className="absolute top-3 left-3 right-1.5 bottom-1.5 rounded-xl border border-white/10" />
      </div>

      {/* Frame-count badge */}
      <div className="absolute top-2 right-2 z-10 flex items-center gap-1 bg-black/70 text-white text-[10px] font-bold px-2 py-1 rounded-full">
        <Layers size={10} />
        <span>{sequence.frameCount} frames</span>
      </div>

      {/* Title overlay */}
      <div className="absolute inset-x-0 bottom-0 p-2.5 z-10 bg-gradient-to-t from-black via-black/70 to-transparent">
        <div className="text-white text-[11px] font-bold leading-tight line-clamp-2 drop-shadow-md">
          {sequence.title ?? "Untitled sequence"}
        </div>
        <div className="text-white/60 text-[9px] mt-0.5">
          {sequence.createdAt ? new Date(sequence.createdAt).toLocaleDateString("pl-PL") : ""}
          {sequence.isInGallery && <span className="ml-1 text-[#ef3e29]">· w galerii</span>}
        </div>
      </div>
    </button>
  );
}
